import React, { useContext, useEffect, useState } from 'react';
import { BsAward, BsCheck, BsExclamation, BsFolderPlus } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import Alert from '../../../components/Alert';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import FormTemplate from '../../../components/FormTemplate';
import { H5 } from '../../../components/Typography/styles';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import {
  ValidationCheckContent,
  ValidationCheckIcon
} from './styles';
import { clientRegistrationSteps, identityValidationSteps } from '../../../helpers/enum';
import { IdentityValidationContext } from '../../../store';
import ModalInfo from '../../../components/ModalInfo';
import ModalActionCongratulations from '../../../components/ModalActionCongratulations';
import Loader from '../../../components/Loader';
import { useForm, Controller } from 'react-hook-form';
import { getAdoCode, validateAdoCode } from '../../../services/ado';
import InputDefault from '../../../components/InputDefault';
import RadioButtonForm from '../../../components/RadioButtonForm';
import { useHistory } from 'react-router-dom';
import { validateIdentitySupplier, validateMetaMapCode } from '../../../services/metamap';
import { validateAnteia } from '../../../services/anteia';

const ValidationCheckPage = ({ setActiveStep, setLastStep }) => {
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const history = useHistory();
  const { register, control, errors, handleSubmit, trigger, setValue } = useForm();
  const { identityValidation, setIdentityValidation } = useContext(IdentityValidationContext);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [showModalInfoNoValida, setShowModalInfoNoValida] = useState(false);
  const [showModalInfoADO, setShowModalInfoADO] = useState(false);
  const [isLoading, setIsLoading] = useState(false);  
  const [showAdoCode, setShowAdoCode] = useState(false);
  const [origenCodigo, setOrigenCodigo] = useState({ label: '', value: '' });
  const [ado, setAdo] = useState(false);
  const [metamap, setMetaMap] = useState(false);
  const [anteia, setAnteia] = useState(false);
  const [superaIntentosMetamap, setSuperaIntentosMetamap] = useState(false);
  const [superaIntentosAdo, setSuperaIntentosAdo] = useState(false);
  const [superaIntentosAnteia, setSuperaIntentosAnteia] = useState(false);

  async function acceptIdentityValidation() {
    try {
      setShowModalInfoADO(false);
      setIsLoading(true);

      const data = {
        idCredito: identityValidation.credit.id,
        idCliente: identityValidation.credit.idCliente,
        idUsuario: session.idAsesor
      }
      setIsLoading(false);
      history.push({
        pathname: '/admin/client-registration/',
        step: clientRegistrationSteps.IDENTITY_FOTO,
        idCredit: data.idCredito,
        idSimulation: identityValidation.solicitation.simulacion.idSimulacion
      });
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  async function onSubmit(dataa) {
    try {
      trigger();
      if (!dataa.adoSegmentCode || dataa.adoSegmentCode.trim() === ''){
        return;
      }
      setIsLoading(true);
      await validateAdoCode(origenCodigo.value, dataa.adoSegmentCode, identityValidation.credit.cliente.identificacion, identityValidation.credit.id, "WEB");
      setIsLoading(false);
      setShowModalInfoADO(true);      
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  async function initAdoCode() {
    try {
      const adoCode = await getAdoCode(identityValidation.credit.id);
      setValue("adoSegmentCode", adoCode.data.idtransaction);
      setShowAdoCode(true);
    }catch (error) {

    }
  }

  async function initMetaMap() {
    try {
      setIsLoading(true);
        const validationMetaMap = await validateMetaMapCode(identityValidation.credit.id);
        if(validationMetaMap.data.estado == "VALIDADO"){
          setValue("adoSegmentCode", "VALIDADO");
          setShowAdoCode(true);
        }
        if(validationMetaMap.data.estado == "EN_ESPERA"){
          setValue("adoSegmentCode", "EN_ESPERA");
          setShowAdoCode(true);
        }
        if(validationMetaMap.data.estado == "RECHAZADO"){
          setValue("adoSegmentCode", "RECHAZADO");
          setShowAdoCode(true);
        }
        if(validationMetaMap.data.estado == '' || validationMetaMap.data.estado.trim() === ''){
          setShowModalInfoNoValida(true);
        }
        setIsLoading(false);
    }catch (error) {
    }
  }

  async function initAnteia() {
    try {
      setIsLoading(true);
        const validationAnteia = await validateAnteia(identityValidation.credit.id);
        if(validationAnteia.data.estado == "VALIDADO"){
          setValue("adoSegmentCode", "VALIDADO");
          setShowAdoCode(true);
        }
        if(validationAnteia.data.estado == "EN_ESPERA"){
          setValue("adoSegmentCode", "EN_ESPERA");
          setShowAdoCode(true);
        }
        if(validationAnteia.data.estado == "RECHAZADO"){
          setValue("adoSegmentCode", "RECHAZADO");
          setShowAdoCode(true);
        }
        if(validationAnteia.data.estado == '' || validationAnteia.data.estado.trim() === ''){
          setShowModalInfoNoValida(true);
        }
        setIsLoading(false);
    }catch (error) {
    }
  }

  function setOrigenCodigoChecked(radio) {
    setOrigenCodigo(radio);
    setShowAdoCode(false);
    setValue("adoSegmentCode", "");
    if (radio.value === 'ADO'){
      initAdoCode();
    }
    if (radio.value === 'METAMAP'){
      initMetaMap();
    }
    if (radio.value === 'ANTEIA'){
      initAnteia();
    }
  }

  async function initIdentityValidation() {
    try {
      const response = await validateIdentitySupplier(identityValidation.credit.id);
      if(response.data.proveedor == 'METAMAP'){
        setMetaMap(true);
        setOrigenCodigoChecked({label: 'METAMAP',value: 'METAMAP'});
        if(response.data.intentos > 2){
          setSuperaIntentosMetamap(true);
        }
      }
      if(response.data.proveedor == 'ADO'){
        setAdo(true);
        setOrigenCodigoChecked({label: 'ADO',value: 'ADO'});
        if(response.data.intentos > 2){
          setSuperaIntentosAdo(true);
        }
      }
      if(response.data.proveedor == 'ANTEIA'){
        setAnteia(true);
        setOrigenCodigoChecked({label: 'ANTEIA',value: 'ANTEIA'});
        if(response.data.intentos > 2){
          setSuperaIntentosAnteia(true);
        }
      }
    }catch (error) {

    }
  }

  async function initializeStateComponent() {
    initIdentityValidation();
  }

  useEffect(() => {
    initializeStateComponent();
  }, []);


  return (
    <FormTemplate 
      idForm="identity-validation-step-page"
      activeStep="1/1"
      stepLabel="Validación de identidad">
      <br></br>
      <H5 color={colors.textPrimary}>Es importante tener en cuenta que para continuar debes contar con la validación de identidad de tu cliente:</H5>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormRow col="2">
        {metamap && !superaIntentosMetamap && 
        <RadioButtonForm
          label="Origen validación identidad"
          setIdentificationRadioChecked={setOrigenCodigoChecked}
          selected={origenCodigo.value}
          name="origenCodigo"
          id="origenCodigo"
          radios={[
            { label: 'METAMAP', value: 'METAMAP' },
          ]}
        />}
        {ado && !superaIntentosAdo && 
          <RadioButtonForm
          label="Origen validación identidad"
          setIdentificationRadioChecked={setOrigenCodigoChecked}
          selected={origenCodigo.value}
          name="origenCodigo"
          id="origenCodigo"
          radios={[
            { label: 'ADO', value: 'ADO' },
          ]}
        />}
         {anteia && !superaIntentosAnteia && 
        <RadioButtonForm
          label="Origen validación identidad"
          setIdentificationRadioChecked={setOrigenCodigoChecked}
          selected={origenCodigo.value}
          name="origenCodigo"
          id="origenCodigo"
          radios={[
            { label: 'ANTEIA', value: 'ANTEIA' },
          ]}
        />}
          {superaIntentosAdo && 
          <RadioButtonForm
          label="Origen validación identidad"
          setIdentificationRadioChecked={setOrigenCodigoChecked}
          selected={origenCodigo.value}
          name="origenCodigo"
          id="origenCodigo"
          radios={[
            { label: 'ADO', value: 'ADO' },
            { label: 'Who is Who', value: 'WHO_IS_WHO' },
          ]}
        />}
        {superaIntentosMetamap && <RadioButtonForm
          label="Origen validación identidad"
          setIdentificationRadioChecked={setOrigenCodigoChecked}
          selected={origenCodigo.value}
          name="origenCodigo"
          id="origenCodigo"
          radios={[
            { label: 'METAMAP', value: 'METAMAP' },
            { label: 'Who is Who', value: 'WHO_IS_WHO' },
          ]}
        />}
        {superaIntentosAnteia && <RadioButtonForm
          label="Origen validación identidad"
          setIdentificationRadioChecked={setOrigenCodigoChecked}
          selected={origenCodigo.value}
          name="origenCodigo"
          id="origenCodigo"
          radios={[
            { label: 'ANTEIA', value: 'ANTEIA' },
            { label: 'Who is Who', value: 'WHO_IS_WHO' },
          ]}
        />}

          
          <Controller
            as={InputDefault}
            control={control}
            label="Código de validación de identidad"
            name="adoSegmentCode"
            register={register({ required: "Este dato es obligatorio" })}
            id="adoSegmentCode"
            error={errors.adoSegmentCode}
            readOnly={showAdoCode} />
        </FormRow>
        <FormFooter justify="flex-end">
          <SecondaryLargeButton type="submit" >Siguiente</SecondaryLargeButton>
        </FormFooter>
      </Form>      
      {isLoading && <Loader />}

      <ModalInfo
        open={showModalInfo}
        setShowModal={setShowModalInfo}
        title="Has excedido el número de intentos"
        description="Espera 24 horas para intentar de nuevo desde la opción del menu Mis solicitudes, o comunicate con el líder para habilitar de nuevo el proceso de prospección del cliente."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />

      <ModalInfo
        open={showModalInfoNoValida}
        setShowModal={setShowModalInfoNoValida}
        title="El cliente no ha realizado el proceso de validación"
        description="El cliente no ha realizado el proceso de validación de identidad."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />

      <ModalActionCongratulations
        open={showModalInfoADO}
        setShowModal={setShowModalInfoADO}
        actionFunctionUpButton={() => acceptIdentityValidation()}
        title="Código de validación de identidad verificado de manera exitosa."
        actionLabelFunctionUpButton="Continuar"
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />
        
    
    </FormTemplate>
  )
}

export default ValidationCheckPage;
